import(/* webpackMode: "eager" */ "/app/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
import(/* webpackMode: "eager" */ "/app/src/components/Footer/Footer.tsx");
import(/* webpackMode: "eager" */ "/app/src/ui/home/hero-section.tsx");
import(/* webpackMode: "eager" */ "/app/src/ui/home/hok-section.tsx");
import(/* webpackMode: "eager" */ "/app/src/ui/home/lol-section.tsx");
import(/* webpackMode: "eager" */ "/app/src/ui/home/valorant-section.tsx");
import(/* webpackMode: "eager" */ "/app/src/ui/home/wildrift-section.tsx");
import(/* webpackMode: "eager" */ "/app/src/ui/ResetSidebarItems.tsx")